import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/dom/ajax';
import buildFetchApiUrl from '../urls/buildFetchApiUrl';

import fetch from 'isomorphic-unfetch';

import type { AjaxOptions, EndpointOptions } from '../../types';

export function createFetch(params) {
  const {
    path,
    allowedParams,
    forcedParams,
    defaultParams,
    requestedProps,
    shouldUseAppUrl,
  } = params;

  return () => {
    return Observable.create(observer => {
      const url = buildFetchApiUrl(
        path,
        allowedParams,
        forcedParams,
        defaultParams,
        requestedProps,
        shouldUseAppUrl,
      );

      fetch(url)
        .then(response => response.json())
        .then(data => {
          observer.next(data);
          observer.complete();
        })
        .catch(err => observer.error(err));
    });
  };
}
